import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";

const MSAL_CONFIG = {
  auth: {
    clientId: window.ENVIRONMENT.azureAdCredentials.clientId,
    authority: window.ENVIRONMENT.azureAdCredentials.authority,
    redirectUri:  window.ENVIRONMENT.azureAdCredentials.redirectUri,
    navigateToLoginRequestUrl: false,
  },
  
  cache: {
    cacheLocation: window.ENVIRONMENT.azureAdCredentials.cacheLocation || BrowserCacheLocation.LocalStorage,
  },
};

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);